import { render, staticRenderFns } from "./ScollPane.vue?vue&type=template&id=b435d556&"
import script from "./ScollPane.vue?vue&type=script&lang=js&"
export * from "./ScollPane.vue?vue&type=script&lang=js&"
import style0 from "./ScollPane.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports